import { useQuery } from 'react-query';
import { useState } from 'react';
import { notificacionService } from '../../services/notificacionService';
import NotificacionesPanel from './NotificacionesPanel';

const NotificacionesBell = () => {
  const [showPanel, setShowPanel] = useState(false);

  const { data } = useQuery(
    'notificaciones-count',
    () => notificacionService.getAll(false, undefined, 1),
    {
      refetchInterval: 30000 // Refrescar cada 30 segundos
    }
  );

  const noLeidas = data?.data.noLeidas || 0;

  return (
    <>
      <button
        onClick={() => setShowPanel(true)}
        className="relative p-2 text-gray-600 hover:text-gray-800"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        {noLeidas > 0 && (
          <span className="absolute top-0 right-0 block h-4 w-4 rounded-full bg-red-600 text-white text-xs flex items-center justify-center">
            {noLeidas > 9 ? '9+' : noLeidas}
          </span>
        )}
      </button>

      {showPanel && (
        <NotificacionesPanel onClose={() => setShowPanel(false)} />
      )}
    </>
  );
};

export default NotificacionesBell;

